import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const FREE_TRIAL_PLAN = {
  key: "freeTrial",
  firebaseKey: "freeTrial",
  nameEn: "Free Trial",
  nameMr: "फ्री ट्रायल",
  price: 0,
  mrp: 0,
  studentLimit: 20,
  durationDays: 7,
  badgeEn: "7 Days Free",
  badgeMr: "७ दिवस मोफत",
  badgeColor: "#6f42c1",
  isTrial: true,
  featuresEn: [
    "7 Days Full Access",
    "Up to 20 Students Limit",
    "Student Record & Registration",
    "Bonafide Certificate Generation",
    "Leaving Certificate (LC / TC)",
    "No Payment / Card Required"
  ],
  featuresMr: [
    "७ दिवस मोफत पूर्ण वापर",
    "कमाल २० विद्यार्थी मर्यादा",
    "विद्यार्थी नोंदणी व रेकॉर्ड",
    "बोनाफाइड प्रमाणपत्र जनरेशन",
    "शाळा सोडल्याचा दाखला (LC)",
    "कोणतेही शुल्क आवश्यक नाही"
  ]
};

const DEFAULT_PAID_PLANS = [
  {
    key: "plan100",
    firebaseKey: "100 Students",
    nameEn: "100 Students Plan",
    nameMr: "१०० विद्यार्थी प्लॅन",
    price: 5000,
    mrp: 5000,
    studentLimit: 100,
    durationDays: 365,
    badgeEn: "Starter",
    badgeMr: "स्टार्टर",
    badgeColor: "#6c757d",
    isTrial: false,
    featuresEn: [
      "Up to 100 Students Limit",
      "Student Record & Registration",
      "Bonafide Certificate Generation",
      "Leaving Certificate (LC / TC)",
      "Student Identity Cards",
      "Standard Reports & Export"
    ],
    featuresMr: [
      "कमाल १०० विद्यार्थी मर्यादा",
      "विद्यार्थी नोंदणी व रेकॉर्ड",
      "बोनाफाइड प्रमाणपत्र",
      "शाळा सोडल्याचा दाखला (LC)",
      "विद्यार्थी ओळखपत्र",
      "मानक अहवाल व निर्यात"
    ]
  },
  {
    key: "plan250",
    firebaseKey: "250 Students",
    nameEn: "250 Students Plan",
    nameMr: "२५० विद्यार्थी प्लॅन",
    price: 10000,
    mrp: 10000,
    studentLimit: 250,
    durationDays: 365,
    badgeEn: "Basic",
    badgeMr: "बेसिक",
    badgeColor: "#0dcaf0",
    isTrial: false,
    featuresEn: [
      "Up to 250 Students Limit",
      "Student Record & Registration",
      "Bonafide Certificate Generation",
      "Leaving Certificate (LC / TC)",
      "Student Identity Cards",
      "Standard Reports & Export"
    ],
    featuresMr: [
      "कमाल २५० विद्यार्थी मर्यादा",
      "विद्यार्थी नोंदणी व रेकॉर्ड",
      "बोनाफाइड प्रमाणपत्र",
      "शाळा सोडल्याचा दाखला (LC)",
      "विद्यार्थी ओळखपत्र",
      "मानक अहवाल व निर्यात"
    ]
  },
  {
    key: "plan500",
    firebaseKey: "500 Students",
    nameEn: "500 Students Plan",
    nameMr: "५०० विद्यार्थी प्लॅन",
    price: 15000,
    mrp: 15000,
    studentLimit: 500,
    durationDays: 365,
    badgeEn: "Popular",
    badgeMr: "लोकप्रिय",
    badgeColor: "#ffc107",
    isTrial: false,
    featuresEn: [
      "Up to 500 Students Limit",
      "All Basic Features",
      "Fee Management & Receipts",
      "Daily Student Attendance",
      "Staff & Teacher Attendance",
      "Fee Due SMS & Notifications"
    ],
    featuresMr: [
      "कमाल ५०० विद्यार्थी मर्यादा",
      "बेसिक प्लॅनच्या सर्व सुविधा",
      "फी व्यवस्थापन व पावती",
      "दैनिक विद्यार्थी उपस्थिती",
      "शिक्षक व कर्मचारी उपस्थिती",
      "फी थकबाकी माहिती व सूचना"
    ]
  },
  {
    key: "plan750",
    firebaseKey: "750 Students",
    nameEn: "750 Students Plan",
    nameMr: "७५० विद्यार्थी प्लॅन",
    price: 20000,
    mrp: 20000,
    studentLimit: 750,
    durationDays: 365,
    badgeEn: "Growth",
    badgeMr: "ग्रोथ",
    badgeColor: "#fd7e14",
    isTrial: false,
    featuresEn: [
      "Up to 750 Students Limit",
      "All 500 Plan Features",
      "Exam & Marksheet System",
      "Progress Report Card Generator",
      "Daily Attendance & SMS",
      "Standard & Custom Reports"
    ],
    featuresMr: [
      "कमाल ७५० विद्यार्थी मर्यादा",
      "५०० प्लॅनच्या सर्व सुविधा",
      "परीक्षा आणि निकाल प्रणाली",
      "प्रगती पुस्तक जनरेटर",
      "दैनिक उपस्थिती व SMS",
      "मानक व कस्टम अहवाल"
    ]
  },
  {
    key: "plan1000",
    firebaseKey: "1000 Students",
    nameEn: "1000 Students Plan",
    nameMr: "१००० विद्यार्थी प्लॅन",
    price: 25000,
    mrp: 25000,
    studentLimit: 1000,
    durationDays: 365,
    badgeEn: "Advanced",
    badgeMr: "प्रगत",
    badgeColor: "#0d6efd",
    isTrial: false,
    featuresEn: [
      "Up to 1000 Students Limit",
      "All 750 Plan Features",
      "Exam & Marksheet System",
      "Class Rank & Analytics",
      "Custom Report Templates",
      "Priority Technical Support"
    ],
    featuresMr: [
      "कमाल १००० विद्यार्थी मर्यादा",
      "७५० प्लॅनच्या सर्व सुविधा",
      "परीक्षा आणि निकाल प्रणाली",
      "गुणवत्ता व कामगिरी विश्लेषण",
      "कस्टम रिपोर्ट टेम्पलेट्स",
      "प्राधान्य तांत्रिक सपोर्ट"
    ]
  },
  {
    key: "plan1500",
    firebaseKey: "1500 Students",
    nameEn: "1500 Students Plan",
    nameMr: "१५०० विद्यार्थी प्लॅन",
    price: 35000,
    mrp: 35000,
    studentLimit: 1500,
    durationDays: 365,
    badgeEn: "Premium",
    badgeMr: "प्रीमियम",
    badgeColor: "#6f42c1",
    isTrial: false,
    featuresEn: [
      "Up to 1500 Students Limit",
      "All Advanced Features",
      "Poshanahar (Midday Meal) Reports",
      "Daily Meal Inventory & Stock",
      "Government Compliance Export",
      "Priority Dedicated Support"
    ],
    featuresMr: [
      "कमाल १५०० विद्यार्थी मर्यादा",
      "सर्व प्रगत सुविधा",
      "पोषण आहार दैनिक नोंद व अहवाल",
      "धान्य व आहार साठा ट्रॅकिंग",
      "शासकीय नियम पूर्ण करणारे रीपोर्ट",
      "प्राधान्य ग्राहक सेवा"
    ]
  },
  {
    key: "plan2000",
    firebaseKey: "2000 Students",
    nameEn: "2000 Students Plan",
    nameMr: "२००० विद्यार्थी प्लॅन",
    price: 45000,
    mrp: 45000,
    studentLimit: 2000,
    durationDays: 365,
    badgeEn: "Ultimate",
    badgeMr: "अल्टिमेट",
    badgeColor: "#198754",
    isTrial: false,
    featuresEn: [
      "Up to 2000 Students Limit",
      "Complete All-in-One School Suite",
      "Full Poshanahar (Midday Meal) System",
      "Custom Report Templates",
      "Government Compliance Export",
      "24/7 Dedicated Priority Support"
    ],
    featuresMr: [
      "कमाल २००० विद्यार्थी मर्यादा",
      "सर्वसमावेशक शाळा व्यवस्थापन",
      "संपूर्ण पोषण आहार प्रणाली",
      "कस्टम रिपोर्ट टेम्पलेट्स",
      "शासकीय नियम पूर्ण करणारे रीपोर्ट",
      "24/7 प्राधान्य ग्राहक सेवा"
    ]
  }
];

const ALL_PLANS = [FREE_TRIAL_PLAN, ...DEFAULT_PAID_PLANS];

function Plans() {
  const [plans, setPlans] = useState(ALL_PLANS);
  const [selectedPlanKey, setSelectedPlanKey] = useState("freeTrial");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const language = localStorage.getItem("language") || "English";

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const adminResponse = await fetch(
          `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/Admin/purchesPlan.json`
        );
        const adminData = await adminResponse.json();
        if (adminData) {
          const mergedPaid = DEFAULT_PAID_PLANS.map((dp) => {
            const remote = adminData[dp.firebaseKey] || adminData[dp.key];
            if (remote) {
              const mrpVal = remote.mrp !== undefined ? parseInt(remote.mrp, 10) : dp.mrp;
              const fixRateVal = remote.fixRate !== undefined ? parseInt(remote.fixRate, 10) : remote.earlyRenewal !== undefined ? parseInt(remote.earlyRenewal, 10) : dp.price;
              const priceVal = isNaN(fixRateVal) ? (isNaN(mrpVal) ? dp.price : mrpVal) : fixRateVal;
              return {
                ...dp,
                price: priceVal,
                mrp: isNaN(mrpVal) ? dp.mrp : mrpVal,
                studentLimit: remote.studentLimit !== undefined ? remote.studentLimit : dp.studentLimit
              };
            }
            return dp;
          });
          setPlans([FREE_TRIAL_PLAN, ...mergedPaid]);
        }
      } catch (err) {
        console.error("Error fetching plans:", err);
      }
    };
    fetchPlans();
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="main-content-of-page"
      style={{
        paddingTop: "90px",
        paddingBottom: "60px",
        paddingLeft: "15px",
        paddingRight: "15px",
        maxWidth: "1600px",
        margin: "0 auto",
        minHeight: "100vh",
        boxSizing: "border-box"
      }}
    >
      {/* Header and back button */}
      <motion.div
        initial={{ y: -30, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.4 }}
        className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2"
      >
        <h2 className="fw-bold text-dark m-0" style={{ fontSize: "1.75rem" }}>
          {language === "English" ? "Subscription Plans" : "सबस्क्रिप्शन प्लॅन्स"}
        </h2>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="btn btn-secondary px-4 py-2 fw-semibold rounded-3 shadow-sm"
          onClick={() => navigate(-1)}
        >
          {language === "English" ? "Back" : "मागे जा"}
        </motion.button>
      </motion.div>

      {/* Plan cards grid */}
      <div className="row g-3 justify-content-center">
        {plans.map((plan) => {
          const isSelected = selectedPlanKey === plan.key;
          const isTrial = plan.isTrial === true || plan.key === "freeTrial";

          return (
            <div
              className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3 d-flex align-items-stretch"
              key={plan.key}
              style={{ minWidth: "240px", maxWidth: "340px" }}
            >
              <div
                className={`card h-100 w-100 shadow-sm border-2 rounded-4 ${
                  isSelected ? "border-primary bg-white shadow-lg" : "border-light bg-light"
                }`}
                style={{
                  cursor: "pointer",
                  transform: isSelected ? "scale(1.03)" : "scale(1)",
                  transition: "all 0.25s ease-in-out",
                  display: "flex",
                  flexDirection: "column"
                }}
                onClick={() => setSelectedPlanKey(plan.key)}
              >
                {/* Header */}
                <div className="card-header bg-transparent border-0 text-center pt-3 pb-1">
                  <span
                    className="badge rounded-pill text-uppercase px-3 py-1 mb-2 text-white fw-bold"
                    style={{ backgroundColor: plan.badgeColor || "#007bff", fontSize: "0.75rem", letterSpacing: "0.5px" }}
                  >
                    {language === "English" ? plan.badgeEn : plan.badgeMr}
                  </span>
                  <h5 className="fw-bold my-1 text-dark" style={{ fontSize: "1.1rem" }}>
                    {language === "English" ? plan.nameEn : plan.nameMr}
                  </h5>

                  {/* Student Limit Badge */}
                  <div className="my-2">
                    <span className="badge bg-primary-subtle text-primary border border-primary-subtle px-2 py-1 fw-bold fs-7">
                      👥 {plan.studentLimit} {language === "English" ? "Students" : "विद्यार्थी"}
                    </span>
                  </div>

                  {/* Price Display */}
                  <div className="my-1">
                    <span className="fs-3 fw-bold text-primary">
                      ₹{plan.price.toLocaleString("en-IN")}
                    </span>
                    <span className="text-muted small">
                      {" "}
                      / {isTrial
                        ? (language === "English" ? "7 days" : "७ दिवस")
                        : (language === "English" ? "year" : "वर्ष")}
                    </span>
                  </div>
                </div>

                {/* Body Features */}
                <div className="card-body d-flex flex-column px-3 pt-2 pb-3">
                  <ul className="list-unstyled mb-3 flex-grow-1">
                    {(language === "English" ? plan.featuresEn : plan.featuresMr).map((feat, idx) => (
                      <li
                        key={idx}
                        className="py-1 border-bottom border-light text-secondary small d-flex align-items-start"
                        style={{ lineHeight: "1.4" }}
                      >
                        <span className="text-success fw-bold me-2 flex-shrink-0">✓</span>
                        <span style={{ wordBreak: "break-word" }}>{feat}</span>
                      </li>
                    ))}
                  </ul>

                  {/* Radio / Selection Indicator */}
                  <div className="form-check text-center mt-auto pt-2">
                    <input
                      className="form-check-input float-none me-2"
                      type="radio"
                      name="plansSelectionIndicator"
                      id={`plan_comp_${plan.key}`}
                      checked={isSelected}
                      onChange={() => setSelectedPlanKey(plan.key)}
                    />
                    <label
                      className="form-check-label fw-bold text-dark small"
                      htmlFor={`plan_comp_${plan.key}`}
                    >
                      {isSelected
                        ? (language === "English" ? "Selected Plan" : "निवडलेला प्लॅन")
                        : (language === "English" ? "Select Plan" : "प्लॅन निवडा")}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </motion.div>
  );
}

export default Plans;